module.exports = __webpack_public_path__ + "static/img/3.f60a465.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/eng/3.png
// module id = StP1
// module chunks = 0